/* tslint:disable */
/* eslint-disable */
/**
 * 3DSurvey API
 * Frontend API for 3d Survey
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateSurveyInput
 */
export interface UpdateSurveyInput {
    /**
     * 
     * @type {string}
     * @memberof UpdateSurveyInput
     */
    surveyUUID: string;
    /**
     * 
     * @type {Date}
     * @memberof UpdateSurveyInput
     */
    date: Date;
    /**
     * 
     * @type {string}
     * @memberof UpdateSurveyInput
     */
    description: string;
}

/**
 * Check if a given object implements the UpdateSurveyInput interface.
 */
export function instanceOfUpdateSurveyInput(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "surveyUUID" in value;
    isInstance = isInstance && "date" in value;
    isInstance = isInstance && "description" in value;

    return isInstance;
}

export function UpdateSurveyInputFromJSON(json: any): UpdateSurveyInput {
    return UpdateSurveyInputFromJSONTyped(json, false);
}

export function UpdateSurveyInputFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateSurveyInput {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'surveyUUID': json['surveyUUID'],
        'date': (new Date(json['date'])),
        'description': json['description'],
    };
}

export function UpdateSurveyInputToJSON(value?: UpdateSurveyInput | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'surveyUUID': value.surveyUUID,
        'date': (value.date.toISOString()),
        'description': value.description,
    };
}

